module.exports = __webpack_public_path__ + "static/img/menage4.b37ca491.png";